<template>
  <div class="tags-container relative py-2" :class="[isOnedioVideo && !isMobile ? 'tags-dark' : 'tags-light']">
    <div class="relative flex flex-row space-x-3 font-medium overflow-x-auto whitespace-nowrap">
      <OLink
        v-for="tag in hashTags"
        :key="tag._id"
        pure
        class="px-4 py-2 text-sm rounded-2xl bg-"
        :class="[isOnedioVideo && !isMobile ? 'bg-[#424242] text-white' : 'bg-[#f7f8fb] text-primary-200']"
        :href="tag.route"
        @click="$analyticsEvent('User', 'User_Engagement', 'action_tag_click')"
      >
        {{ tag.name }}
      </OLink>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { isVideoArticle } from '../utils/articleUtils';
import { useDevice } from '~/composables/useDevice';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLink },
  props: {
    stn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article');
    const hashTags = computed(() => article?.hashtags);
    const isOnedioVideo = computed(() => isVideoArticle(article) && !props.stn);
    const { isMobile } = useDevice();
    return { hashTags, isOnedioVideo, isMobile };
  },
});
</script>

<style lang="scss">
.tags-container {
  &:after {
    content: '';
    position: absolute;
    right: 0px;
    top: 0px;
    width: 40px;
    height: 100%;
  }
}
.tags-dark {
  &:after {
    background: rgb(24, 24, 25);
    background: linear-gradient(270deg, rgb(24, 24, 25) 0%, rgba(255, 255, 255, 0) 100%);
  }
}

.tags-light {
  &:after {
    background: rgb(255, 255, 255);
    background: linear-gradient(270deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  }
}
</style>
